import { BracketType } from './RelativeMoneyFormatter.model';

export function calculateRelativePrice(
  price: number,
  basePrice: number,
  currency: string,
  formatMoney: (price: number, currency: string) => string
): string {
  const priceDiff = price - basePrice;

  if (priceDiff > 0) {
    const priceString = formatMoney(priceDiff, currency);
    return `+ ${priceString}`;
  } else {
    const priceString = formatMoney(priceDiff * -1, currency);
    return `- ${priceString}`;
  }
}

export function decorateWithBrackets(
  value: string,
  bracketType: BracketType
): string {
  switch (bracketType) {
    case BracketType.None:
      return value;
    case BracketType.Curly:
      return `{${value}}`;
    case BracketType.Round:
      return `(${value})`;
    case BracketType.Square:
      return `[${value}]`;
  }
}
